import { ITableColumn } from '@components/common/UTable/UTable';

import { DOSAGE_UNIT_LABELS } from '@/shared/pharmacy/enum';
import { enumToOptions } from '@/utils/utils';

export const tasksTableColumns: ITableColumn[] = [
  { title: '№ п/п', dataIndex: 'index', width: 50 },
  {
    title: 'Препараты согласно наряду',
    dataIndex: 'name',
  },
  {
    title: 'Номер партии',
    dataIndex: 'batchNumber',
  },
  {
    title: 'Дата конца срока годности партии',
    type: 'date',
    dataIndex: 'expirationDate',
  },
  {
    title: 'Необходимый объем препарата для наряда',
    dataIndex: 'usedVolume',
  },
  {
    title: 'Количество необходимых ед. тары',
    dataIndex: 'packagesAmount',
  },
  {
    title: 'Объем/доза препарата на единицу тары',
    dataIndex: 'packageVolume',
    render: (value: any) => value,
    // если появятся единицы измерения - раскомментить
    // `${value} ${
    //   DOSAGE_UNIT_LABELS_SHORT[
    //     record?.dosageUnit as keyof typeof DOSAGE_UNIT_LABELS_SHORT
    //   ]
    // }`,
  },
];

export const drugExpenseColumns = (onAmountSave: any, displayEditButton: boolean) =>
  [
    {
      title: '№ партии',
      dataIndex: 'batchNumber',
      width: 200,
    },
    {
      title: 'Дата конца срока годности партии',
      dataIndex: 'expirationDate',
      type: 'date',
      width: 150,
    },
    {
      title: 'Срок годности после вскрытия (дней)',
      dataIndex: 'expirationPeriod',
      width: 150,
    },
    {
      title: 'Количество единиц тары\nв наличии',
      dataIndex: 'packagesAmount',
      width: 150,
    },
    {
      title: 'Единица содержимого',
      dataIndex: 'dosageUnit',
      type: 'select',
      payload: {
        options: enumToOptions(DOSAGE_UNIT_LABELS),
      },
      width: 150,
    },
    {
      title: 'Объем/доза препарата\nна единицу тары',
      dataIndex: 'packageVolume',
      width: 150,
    },
    {
      title: 'Количество единиц хранения к списанию',
      dataIndex: 'usedPackages',
      editable: {
        type: 'number',
        step: 1,
        precision: 2,
        min: 0,
        onSave: async (record, value) => {
          await onAmountSave(record?.drugBatchId, value);
        },
        displayEditButton,
      },
      width: 150,
    },
  ] as ITableColumn[];
